/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.7.5
@license MIT
@copyright (c) 2017, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __ol = _interopDefault(require('openlayers'));
var core = require('../core');

var Stroke = __ol.style.Stroke;
var props = {
  color: [Array, String],
  lineCap: {
    type: String,
    default: 'round' // round, butt, square
  },
  lineJoin: {
    type: String,
    default: 'round' // round, bevel, miter
  },
  lineDash: Array,
  lineDashOffset: {
    type: Number,
    default: 0
  },
  miterLimit: {
    type: Number,
    default: 10
  },
  width: {
    type: Number,
    default: 1.25
  }
};

var methods = {
  /**
   * @return {ol.style.Stroke}
   * @protected
   */
  createStyle: function createStyle() {
    return new Stroke({
      color: this.color,
      lineCap: this.lineCap,
      lineJoin: this.lineJoin,
      lineDash: this.lineDash,
      lineDashOffset: this.lineDashOffset,
      miterLimit: this.miterLimit,
      width: this.width
    });
  },

  /**
   * @return {void}
   * @protected
   */
  mount: function mount() {
    this.$stylesContainer && this.$stylesContainer.setStroke(this);
  },

  /**
   * @return {void}
   * @protected
   */
  unmount: function unmount() {
    this.$stylesContainer && this.$stylesContainer.setStroke(undefined);
  }
};

var watch = {
  color: function color(value) {
    if (!this.$style) return;

    this.$style.setColor(value);
    this.refresh();
  },
  lineCap: function lineCap(value) {
    if (!this.$style) return;

    this.$style.setLineCap(value);
    this.refresh();
  },
  lineDash: function lineDash(value) {
    if (!this.$style) return;

    this.$style.setLineDash(value);
    this.refresh();
  },
  lineJoin: function lineJoin(value) {
    if (!this.$style) return;

    this.$style.setLineJoin(value);
    this.refresh();
  },
  width: function width(value) {
    if (!this.$style) return;

    this.$style.setWidth(value);
    this.refresh();
  }
};

var Style = {
  name: 'vl-style-stroke',
  mixins: [core.style],
  props: props,
  watch: watch,
  methods: methods
};

var index = {
  Style: Style,
  install: function install(Vue) {
    Vue.component(Style.name, Style);
  }
};

module.exports = index;

//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/stroke-style/index.js
// module id = 1197
// module chunks = 1